<template>
  <div style="padding: 10px; overflow-y: auto; height: 100%;">
    <div v-if="loading" style="text-align: center; margin-top: 2em;">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
    </div>
    <div v-else-if="checkouts.length === 0" style="padding: 20px; text-align: center; color: gray;">
      No clinician holds found.
    </div>
    <table v-else class="data-table" cellspacing="0" style="width: 100%;">
      <tr class="table-headers">
        <th style="text-align: left;">Date</th>
        <th style="text-align: left;">Clinician</th>
        <th style="text-align: left;">Notes</th>
        <th style="text-align: left;">Status</th>
        <th style="text-align: right;"></th>
      </tr>
      <tbody class="table-data" v-for="(item, index) in checkouts" :key="index">
        <tr class="drugtablerow" style="height: 40px; cursor: pointer;" @click="item.expand = !item.expand" :class="[item.expand ? 'open-transfer-row' : '']">
          <td style="padding: 5px; border-bottom: 1px solid #ccc;">
            <i :class="item.expand ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" style="margin-right: 5px; font-size: 0.8em;"></i>
            {{ new Date(item.created_at).toLocaleString() }}
          </td>
          <td style="padding: 5px; border-bottom: 1px solid #ccc;">
            {{ item.clinician && item.clinician.personal_information ? item.clinician.personal_information.firstname + ' ' + item.clinician.personal_information.lastname : 'N/A' }}
          </td>
          <td style="padding: 5px; border-bottom: 1px solid #ccc; max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ item.notes || 'None' }}
          </td>
          <td style="padding: 5px; border-bottom: 1px solid #ccc;">
            <span :class="item.status === 'open' ? 'green-tag' : 's8-tag'" style="padding: 3px 8px; border-radius: 4px; font-weight: bold;">
              {{ item.status.toUpperCase() }}
            </span>
          </td>
          <td style="padding: 5px; border-bottom: 1px solid #ccc; text-align: right;">
            <button class="submit-button blue-button" style="margin: 0; padding: 5px 15px; font-size: 0.9em;" @click.stop="openCheckIn(item)">Check In</button>
          </td>
        </tr>
        <tr v-if="item.expand" class="expanded-content-row">
          <td colspan="5" style="padding: 10px; background-color: #f9f9f9; border-bottom: 1px solid #ccc;">
            <div style="margin-bottom: 5px;" v-if="item.notes"><span style="font-weight: bold;">Notes:</span> {{ item.notes }}</div>
            <div v-if="item.drugs && item.drugs.length > 0">
              <span style="font-weight: bold; display: block; margin-bottom: 8px;">Medications:</span>
              <ul style="margin: 0 0 0 20px; padding: 0;">
                <li v-for="(drug, dIndex) in item.drugs" :key="dIndex" style="margin-bottom: 6px; display: flex; align-items: flex-start;">
                  <strong style="white-space: nowrap; margin-right: 8px; flex-shrink: 0; margin-top: 2px;">
                    {{ drug.qty || drug.quantity }} {{ drug.stock_item && drug.stock_item.alias && drug.stock_item.alias.form ? drug.stock_item.alias.form : 'x' }}
                  </strong>
                  <div @click="drug.expanded = !drug.expanded" style="flex: 1; cursor: pointer; line-height: 1.4;" :style="{ whiteSpace: drug.expanded ? 'normal' : 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }" :title="drug.expanded ? 'Click to collapse' : 'Click to expand'">
                    <span v-if="drug.stock_item && drug.stock_item.alias && drug.stock_item.alias.generic_name && drug.stock_item.alias.generic_name.toLowerCase() !== drug.stock_item.alias.name.toLowerCase()">
                      <span style="color: #666; font-size: 0.9em; margin-right: 4px;">({{ drug.stock_item.alias.generic_name }})</span> {{ drug.stock_item.alias.name }}
                    </span>
                    <span v-else>
                      {{ drug.stock_item && drug.stock_item.alias ? drug.stock_item.alias.name : 'Unknown Medication' }}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div v-else style="color: gray; font-style: italic; margin-bottom: 8px;">No medications recorded.</div>
          </td>
        </tr>
      </tbody>
    </table>

    <ClinicianHoldCheckinModal 
        v-if="showCheckinModal" 
        :preselectedCheckoutId="selectedHoldToVerify" 
        @close="closeCheckinModal" 
        @isSuccessful="onCheckinSuccess" 
    />
    
    <ClinicianHoldCheckoutModal
        v-if="showCheckoutModal"
        @close="closeCheckoutModal"
        @isSuccessful="onCheckoutSuccess"
    />
  </div>
</template>

<script>
import axios from 'axios';
import ClinicianHoldCheckinModal from '@/components/modals/ClinicianHoldCheckinModal.vue';
import ClinicianHoldCheckoutModal from '@/components/modals/ClinicianHoldCheckoutModal.vue';

export default {
  name: 'ClinicianHolds',
  components: {
    ClinicianHoldCheckinModal,
    ClinicianHoldCheckoutModal
  },
  data() {
    return {
      loading: false,
      checkouts: [],
      showCheckinModal: false,
      showCheckoutModal: false,
      selectedHoldToVerify: null
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    openCheckIn(item) {
      this.selectedHoldToVerify = item.uuid;
      this.showCheckinModal = true;
    },
    closeCheckinModal() {
      this.showCheckinModal = false;
      this.selectedHoldToVerify = null;
    },
    onCheckinSuccess() {
      this.closeCheckinModal();
      this.fetchData();
    },
    closeCheckoutModal() {
      this.showCheckoutModal = false;
    },
    onCheckoutSuccess() {
      this.closeCheckoutModal();
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      axios.post('/get-open-clinician-holds', {}, this.$store.state.header).then(res => {
        this.checkouts = (res.data.data || []).map(item => {
            item.expand = false;
            if (item.drugs) {
                item.drugs = item.drugs.map(d => ({ ...d, expanded: false }));
            }
            return item;
        });
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        console.error("Failed to fetch clinician holds", err);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.open-transfer-row {
  background-color: #e5f1fe !important;
}
.expanded-content-row td {
  background-color: #fafafa !important;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
}
</style>
